/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

import { Polymer, html } from '@polymer/polymer/polymer-legacy.js'; 
import './fin-auth-secureimage.js';  
import './fin-auth-pushnotification.js';
import './fin-auth-softtoken.js';
const template = html`
<custom-style>
        <style include="login-styles">
        .view-port {
            overflow-x: auto;
            overflow-y: auto;
            height: 100%;
        }
        .view-port::-webkit-scrollbar {
            display: none;
        }
        </style>
</custom-style>
<!-- api for changeauthmode -->
<oe-ajax id="authModeChange" method="post" content-type="application/json" on-response="handleAuthModeresponse" on-error="handleError"></oe-ajax>

        <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}"></app-media-query>
         <iron-pages class="view-port" selected="{{selectedModePage}}">
            <fin-auth-secureimage selected-mode-page="{{selectedModePage}}" selected-page={{selectedPage}} auth-mode-response={{authModeResponse}} auth-mode-body={{authModeBody}} auth-success={{authSuccess}} selected-value = {{selectedValue}} auth-mode-list={{authModeList}} reset-mpin={{resetMpin}}></fin-auth-secureimage>
            <fin-auth-pushnotification selected-mode-page="{{selectedModePage}}" selected-page={{selectedPage}} auth-mode-response={{authModeResponse}} auth-mode-body={{authModeBody}} auth-success={{authSuccess}} selected-value = {{selectedValue}} auth-mode-list={{authModeList}} reset-mpin={{resetMpin}}></fin-auth-pushnotification>
            <fin-auth-softtoken selected-mode-page="{{selectedModePage}}" selected-page={{selectedPage}} auth-mode-response={{authModeResponse}} auth-mode-body={{authModeBody}} auth-success={{authSuccess}} softtoken-otp={{softtokenOtp}} selected-value = {{selectedValue}} auth-mode-list={{authModeList}} reset-mpin={{resetMpin}}></fin-auth-softtoken>
         </iron-pages>`;
  
        Polymer({
            is: 'fin-auth-modes-landing',
            _template:template,
            properties: {
                selectedModePage:{
                  type:Number,
                  notify:true
              },
              selectedPage: {
                  type: Number,
                  notify: true 
              },
              authModeResponse: {
                  type: Object,
                  notify: true,
                  observer:'_checkAuthmode' 
              },
              fromQrSuccess:{
                  type: Boolean,
                  notify: true 
              },
              fromPlaystore:{
                  type: Boolean,
                  notify: true 
              },
              selectedFlag: {
                  type: Boolean,
                  notify: true 
              },
              authModeBody: {
                  type: Object,
                  notify: true 
              },
              authSuccess: {
                  type: Boolean,
                  notify: true 
              },
              softtokenOtp:{
                  type: String,
                  notify: true 
              },
              selectedValue: {
                  type: String,
                  notify: true,
                  observer:'setAuthmode'
              },
              authModeList: {
                  type: Array,
                  notify: true 
              },
              resetMpin:{
                  type: Boolean, 
                  notify: true 
              },
              authModeObject:{
                  type: Object,
                  notify: true 
              }
            },
            _checkAuthmode(){
                if(this.authModeResponse!=undefined && this.authModeResponse.primaryAuthenticationMode!=undefined){
                    if(this.authModeResponse.primaryAuthenticationMode.cmCode=="VIMG"){
                        this.selectedModePage=0;
                    } 
                    else if(this.authModeResponse.primaryAuthenticationMode.cmCode=="PUSH"){
                        this.selectedModePage=1;
                    } 
                    else if(this.authModeResponse.primaryAuthenticationMode.cmCode=="STKN"){
                        this.selectedModePage=2;
                    } 
                } 
            } ,
            setAuthmode(){
                if(this.selectedValue!="" && this.selectedValue!=undefined){ 
                    if(this.selectedValue=="STKN"){
                        var stkn={
                            "codeType": "ATN",
                            "cmCode": "STKN",
                            "codeDescription": "Soft Token"
                        }
                        this.authModeObject={}
                        this.authModeObject.primaryAuthenticationMode=stkn;
                        // this.authModeResponse={};
                        // this.authModeResponse.primaryAuthenticationMode=stkn;
                        this.selectedModePage=2;
                    }else{
                        this.$.authModeChange.url = "/auth/customregeneratepassword";
                        //this.popDataForCredentialRequest();
                        var Data=JSON.parse(this.authModeBody);
                        Data.emailId="";
                        Data.authenticationMode=this.selectedValue;
                        Data.password=""; 
                        this.$.authModeChange.body=JSON.stringify(Data); 
                        this.$.authModeChange.generateRequest();
                        this.fire('start-processing-loader');
                    } 
                }
            },
            
            handleAuthModeresponse(e){
                this.fire('stop-processing-loader');
                var Response=e.detail.response;
                if(Response.code==400 || Response.code==503 ){
                    this.fire('oe-show-error',Response.error_description);
                }
                else{
                    this.authModeObject={}
                    this.authModeObject.primaryAuthenticationMode=Response.primaryAuthenticationMode;
                    if(Response.ochTransactionId!=undefined){
                        this.authModeObject.ochTransactionId=Response.ochTransactionId;
                    }
                    this.authModeResponse=Response; 
                    this._checkAuthmode();
                }
               
            }
            
        }); 
